import { useSelector } from "react-redux";
import Layout from "./layout";
import LoginForm from "../auth/loginForm";
import RegisterForm from "../auth/registerForm";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { fetchEtablissementById } from "../../store/slices/etablissementSlice";
import { useEffect } from "react";
import { createRendezvous } from "../../store/slices/rendezVousSlice";

const IdentificationRegister=()=>{
  const dispatch=useDispatch()
  const {id}=useParams()
  const location=useLocation()
  const navigate=useNavigate()
    const data=location?.state
  
    const etablissement = useSelector(
        (state) => state.etablissements.selectedEtablissement
      );
      const prestations = useSelector(
        (state) => state.rendezvous.selectedPrestations
      );
  useEffect(() => {
       dispatch(fetchEtablissementById(id));
     }, []);
     // after register not complete ( à faire)
       const afterLogin=async()=>{
              try {
                       // Dispatch the create appointment action
                       const resultAction = await dispatch(
                         createRendezvous(data)
                       );
             
                       if (createRendezvous.fulfilled.match(resultAction)) {
                         // Success case
                         localStorage.setItem('resultAction',JSON.stringify(resultAction?.payload?.reservation))
                        //  console.log('hereee')
                          navigate(`/facturation/${resultAction?.payload?.reservation?.id}`);
                       } else {
                         // Handle error case
                        //  console.error(
                        //    "Failed to create appointment:",
                        //    resultAction.payload
                        //  );
                         // alert("Erreur lors de la création du rendez-vous");
                       }
                     } catch (error) {
                      //  console.error("Error creating appointment:", error);
                       // alert("Une erreur est survenue");
                     }
           }
    return(
        <>
        <Layout
          currentStep={2}
          etablissement={etablissement}
          prestation={prestations.filter((p) => p.selected)}
          recap={false}
          identification={true}
          conf={true}
          from='reservation'
          btn={false}
    >
      <div className="mb-24 mx-auto">
        <RegisterForm from='rdv' id={etablissement?.id} after={afterLogin} />
      </div>
      </Layout>
        </>
    )
}
export default IdentificationRegister;